import { FC } from "react";

import { ToolbarFilterButton } from "@/components/_molecules/toolbar-filter-button";

import { DatatableFilterDropdown } from "./datatable-filter-dropdown";

export const AddAdditionalFilterButton: FC = () => (
  <DatatableFilterDropdown side="bottom" asChild={true}>
    <ToolbarFilterButton />
  </DatatableFilterDropdown>
);
